type AnalyticsProgressBarProps = {
  progress: number;
};

export const AnalyticsProgressBar = ({ progress }: AnalyticsProgressBarProps) => {
  const clampedProgress = Math.min(Math.max(progress, 0), 100);

  return (
    <div className="tw-h-[10px] tw-w-full tw-rounded-[20px] tw-bg-[#314272]">
      <div
        className="tw-h-full tw-rounded-[20px] tw-bg-gamefieldProgressGradient tw-transition-all tw-duration-300"
        style={{ width: `${clampedProgress}%` }}
      />
    </div>
  );
};
